export const language = {
    "Custom Design": "Benutzerdefiniertes Design",
    "Cancel": "Abbrechen",
    "Update": "Aktualisieren",
    "Save": "Speichern",
}